export default __webpack_public_path__ + "static/media/doubleLine.68e66782.svg";